export const environment = {
  production: true,
  apiURL: 'https://api.point-s.pl',
  userType: 'ALD',
  appName: 'ServiceApp',
  oldAppURL: 'http://swz.mm.com.pl/',
  menuPosition: 'side', // 'side', 'top', 'none'
  reconnectionTime: 15000, // try reconnect to web socket after reconnectionTime [ms]
  compactViewWidth: 1080, // if screen innerWidth < compactViewWidth -> some items of minidashboard will be hidden};
  tooltipDelay: 500,

};


